import axios from "@/assets/js/httpUtil.js";
import { baseUrl } from "./env";
//获取用户健康值接口
export const getPersionHValueDetail = (params) => {
  return axios.get(
    baseUrl + "/cms/healthArchive/2.0/healthValue/getHValueDetail",
    {
      params,
    }
  );
};

//获取用户问题(风险因素)接口
export const getHRiskFactorIssue = (params) => {
  return axios.get(baseUrl + "/hplatform/2.0/healthValue/getHRiskFactorIssue", {
    params,
  });
};

//获取用户疾病风险评估接口
// export const getHealthRiskEstimateList = (params) => {
//   return axios.get(
//     baseUrl + "/hplatform/2.0/healthValue/getHealthRiskEstimateList",
//     {
//       params,
//     }
//   );
// };
//获取用户疾病风险评估接口-拓荒
export const getHealthRiskEstimateList = (params) => {
  return axios.get(baseUrl + "/cms/healthArchive/userRiskDisease/info", {
    params,
  });
};

//获取健康档案单疾病风险详情接口
// export const getRValueDiseaseInfo = (params) => {
//   return axios.get(
//     baseUrl + "/hplatform/2.0/healthValue/getRValueDiseaseInfo",
//     {
//       params,
//     }
//   );
// };
//获取健康档案单疾病风险详情接口-拓荒
export const getRValueDiseaseInfo = (params) => {
  return axios.get(
    baseUrl + "/cms/healthArchive/userRiskDisease/single/detail",
    {
      params,
    }
  );
};

//获取健康值趋势
export const getUserHValueHistory = (params) => {
  return axios.get(
    baseUrl + "/cms/healthArchive/2.0/healthValue/getUserHValueHistory",
    {
      params,
    }
  );
};

// 获取健康档案信息
export const getArchive = (params) => {
  return axios.get(
    baseUrl + "/cms/healthArchive/2.0/healthValue/getHValueInfoToB",
    {
      params,
    }
  );
};

// 分页查询健康档案基础数据
export const getHPageItem = (params) => {
  return axios.get(
    baseUrl + "/cms/healthArchive/2.0/healthValue/getHPageItem",
    {
      params,
    }
  );
};

// 获取用户健康概览异常指标预测
export const getAbnormalWarning = (params) => {
  return axios.get(baseUrl + "/cms/anomalyIndex/getAbnormalWarning", {
    params,
  });
};

// 获取用户异常指标预警详情
export const getRecordsList = (params) => {
  return axios.get(baseUrl + "/cms/anomalyIndex/getRecordsList", {
    params,
  });
};

// 获取全部风险因素
export const getAllRiskFactor = (params) => {
  return axios.get(baseUrl + "/cms/riskFactor/all", {
    params,
  });
};
// 获取健康档案用户风险因数影响程度接口
export const getHRiskFactorList = (params) => {
  // return axios.get(baseUrl + "/hplatform/2.0/healthValue/getHRiskFactorList", {
  return axios.get(baseUrl + "/cms/user/riskFactors", {
    params,
  });
};

// 获取用户健康档案异常指标详情
export const getHAbnormalIndicator = (params) => {
  return axios.get(
    // baseUrl + "/hplatform/2.0/healthAbnormalIndicator/getHAbnormalIndicator",
    baseUrl + "/api/anomalyIndex/getAbnormalRecords",
    {
      params,
    }
  );
};

// 获取健康档案用户疾病指向历史记录图表-飞扬
export const getBubbleData = (params) => {
  return axios.get(baseUrl + "/cms/anomalyIndex/getBubbleData", {
    params,
  });
};

// 获取用户健康档案部分评测记录（健康档案详情）
export const getUserDocRecordDetail = (params) => {
  return axios.get(
    baseUrl +
      "/cms/healthArchive/2.0/healtUserDocRecord/getUserDocRecordDetail",
    {
      params,
    }
  );
};

// 获取健康档案基本信息-生活方式
export const getUserModuleDoc = (params) => {
  return axios.get(
    baseUrl + "/cms/healthArchive/2.0/healthValue_B/getUserModuleDoc",
    {
      params,
    }
  );
};

/**
 * 健康数据
 */

// 获取健康档案用户健康值
export const getHealthHValue = (params) => {
  return axios.get(
    baseUrl + "/hplatform/v2/health-user-h-value/getHealthHValue",
    {
      params,
    }
  );
};

// 获取健康档案所有疾病风险
export const getHealthHasControlRiskFactorList = (params) => {
  return axios.get(
    baseUrl +
      "/hplatform/v2/healthRiskFactor/getHealthHasControlRiskFactorList",
    {
      params,
    }
  );
};

// 获取健康档案用户健康值趋势 手机号
export const getHealthUserHValueTrend = (params) => {
  return axios.post(
    baseUrl + "/hplatform/v2/health-user-h-value/getHealthUserHValueTrend",
    {
      ...params,
    },
    {
      toJSON: true,
    }
  );
};

// 获取健康档案用户健康值趋势  pid
export const getHealthUserHValueTrendpid = (params) => {
  return axios.post(
    baseUrl + "/hplatform/2.0/healthValue/getHealthUserHValueTrend",
    {
      ...params,
    },
    {
      toJSON: true,
    }
  );
};

// xueya
// export const getAnomalData = (params) => {
//   return axios.post(
//     feiyang + "/api/anomalyIndex/getAnomalData",
//     {
//       ...params,
//     },
//     {
//       toJSON: true,
//     }
//   );
// };
export const getAnomalData = (params) => {
  return axios.post(baseUrl + "/cms/anomalyIndex/getAnomalOne", params, {
    toJSON: true,
  });
};
//获取健康档案用户异常指标统计数据列表-通过用户手机号
export const getHealthUserAbnormalIndicatorStatisticsList = (params) => {
  return axios.get(
    baseUrl +
      "/hplatform/v2/healthAbnormalIndicatorPhone/getHealthUserAbnormalIndicatorStatisticsList",
    {
      params,
    }
  );
};

//获取健康档案用户疾病指向历史记录
export const getHealthDiseasePointHistoryList = (params) => {
  return axios.get(
    baseUrl +
      "/hplatform/2.0/healthDiseasePointPhone/getHealthDiseasePointHistoryList",
    {
      params,
    }
  );
};

//获取健康档案用户异常指标列表-通过用户手机号
export const getHealthUserAbnormalIndicatorList = (params) => {
  return axios.get(
    baseUrl +
      "/hplatform/v2/healthAbnormalIndicatorPhone/getHealthUserAbnormalIndicatorList",
    {
      params,
    }
  );
};

//获取健康档案用户异常指标详情-通过用户手机号
export const getHealthAbnormalIndicator = (params) => {
  return axios.get(
    baseUrl +
      "/hplatform/v2/healthAbnormalIndicatorPhone/getHealthAbnormalIndicator",
    {
      params,
    }
  );
};

//获取健康档案用户健康值历史记录
export const getUserHistoryHValue = (params) => {
  return axios.get(
    baseUrl + "/cms/healthArchive/2.0/healthValue/getUserHistoryHValue",
    {
      params,
    }
  );
};

//获取健康档案用户所有疾病风险详情
export const getHealthUserAllDiseaseRisk = (params) => {
  return axios.get(
    baseUrl + "/hplatform/v2/healthRiskFactor/getHealthUserAllDiseaseRisk",
    {
      params,
    }
  );
};

//获取健康档案用户所有疾病风险详情
export const getHealthRiskFactorList = (params) => {
  return axios.get(
    baseUrl + "/hplatform/v2/healthRiskFactor/getHealthRiskFactorList",
    {
      params,
    }
  );
};

//根据风险因数id获取对应的疾病风险
export const getHealthRiskFactorListById = (params) => {
  return axios.get(
    baseUrl + "/hplatform/v2/healthRiskFactor/getHealthRiskFactorListById",
    {
      params,
    }
  );
};

//获取健康档案单疾病风险详情
export const getHealthRValueDiseaseInfo = (params) => {
  return axios.get(
    baseUrl + "/hplatform/v2/healthRiskFactor/getHealthRValueDiseaseInfo",
    {
      params,
    }
  );
};

//B端-获取健康档案信息-通过用户手机号
export const getHValueInfoToBV2 = (params) => {
  return axios.get(
    baseUrl + "/hplatform/2.0/healtUserDocRecordPhone/getHValueInfoToBV2",
    {
      params,
    }
  );
};

//获取健康档案基本信息-生活方式-通过用户手机号
export const getUserModuleDocV2 = (params) => {
  return axios.get(
    baseUrl + "/hplatform/2.0/healtUserDocRecordPhone/getUserModuleDocV2",
    {
      params,
    }
  );
};

//获取健康档案用户某项评测历史数据-手机号
export const getUesrHistoryHealthDocRecordByPhoneNumber = (params) => {
  return axios.get(
    baseUrl +
      "/hplatform/2.0/healtUserDocRecordPhone/getUesrHistoryHealthDocRecordByPhoneNumber",
    {
      params,
    }
  );
};

// 获取健康档案基本信息-体检信息
export const getUserDocRecordDetailByProfileId = (params) => {
  return axios.get(
    baseUrl +
      "/cms/healthArchive/2.0/healtUserDocRecord/getUserDocRecordDetailByUserId",
    {
      params,
    },
    null
  );
};

// 获取健康档案基本信息-体检信息-通过手机号
export const getUserDocRecordDetailByPhoneNumber = (params) => {
  return axios.get(
    baseUrl +
      "/hplatform/2.0/healtUserDocRecordPhone/getUserDocRecordDetailByPhoneNumber",
    {
      params,
    },
    null
  );
};

// 获取健康档案异常指标筛选条件-通过用户id
export const getScreenConditionByProfileId = (params) => {
  return axios.get(
    baseUrl + "/hplatform/api/health-base/getScreenConditionByProfileId",
    {
      params,
    },
    null
  );
};

// 获取健康档案异常指标筛选条件-通过手机号
export const getScreenConditionByPhoneNumber = (params) => {
  return axios.get(
    baseUrl + "/hplatform/api/health-base/getScreenConditionByPhoneNumber",
    {
      params,
    },
    null
  );
};

// 获取健康档案体检报告列表检查机构
export const getReportMedicalInstitutionList = (params) => {
  return axios.get(
    baseUrl + "/hplatform/medicalReport/getReportMedicalInstitutionList",
    {
      params,
    },
    null
  );
};
//获取客户列表
export const getClientList = (params) => {
  return axios.get(baseUrl + "/hplatform/client-manager/getClientList", {
    params,
  });
};
//根据用户检索机构检索体检报告
export const searchUserListReport = (params) => {
  return axios.get(baseUrl + "/hplatform/medicalReport/searchUserListReport", {
    params,
  });
};
